<template>
<div  class="modal-wrapper colored-modal-wrapper user-identity" style="top: 0; left: 0">
    <div class="modal" data-aos="fade-left">

        <div v-if="requestMessage">
            <div class="looking-animation">
                <Vue3Lottie :speed="0.8" :animationData="confirmedDeletionAnimation" />
            </div>

            <div class="modal-title modal-title-sm">
                <p>Deine Datenlöschung wird rechtlich beantragt!</p>
            </div>
        </div>

        <div v-else>
            <div class="modal-title modal-title-sm">
                <p v-if="ticketStatus == 4">Datenlöschung gemäss revDSG / DSGVO</p>
                <p v-else>Bestätigung</p>
            </div>

            <div class="modal-msg">
                <p v-if="ticketStatus == 4">Möchtest du, dass wir die Löschung deiner Daten rechtlich<br> einfordern, durchsetzen und bestätigen lassen?</p>

                <p v-else>Bist du dir sicher, dass du diesem Unternehmen deine Daten zur<br> Verfügung stellen willst?</p>
            </div>

            <div class="buttons-wrapper">
                <button @click="closeModal()" class="modal-btn modal-btn-sm modal-btn-white">
                    <p>Abbrechen</p>
                </button>

                <button v-if="loadingBtn" class="modal-btn loading-btn">
                    <div class="loader"></div>
                </button>

                <button v-else @click="sendTheDeletionRequest()" class="modal-btn modal-btn-sm"> 
                    <p>Bestätigen</p>
                </button>
            </div>

        </div>

    </div>
</div>
</template>

<script>
import confirmedDeletionAnimation from '../../assets/animations/confirmed-deletion.json';
export default {
    data() {
        return {
            confirmedDeletionAnimation,
            requestMessage: false,
            // loading: false,
            loadingBtn: false,
        }
    },
    computed: {

    },
    methods: {
        closeModal() {
            this.$store.commit("application/setDeleteDataRequestModal", false);
            this.$store.commit("application/setTicketId", null);
            this.$store.commit("application/setTicketStatus", null);
        },

        async resetData() {
            this.requestMessage = false;
            this.loadingBtn = false;
            this.closeModal();
            await this.getTicketsReplyData();
        },

        async sendTheDeletionRequest() {
            this.loadingBtn = true;

            const id = this.ticketId;
            const status = this.ticketStatus;

            try {
                await this.updateTicketStatus({
                    id: id,
                    newStatus: status
                });

                this.requestMessage = true;

                setTimeout(() => {
                    this.resetData();
                }, "3500");
            } catch (err) {
                this.$store.commit("application/setErrorProcessModal", true);
                this.$store.commit("application/setErrorProcessTitle", 'Beim Aktualisieren des Status ist ein Fehler aufgetreten!');
                this.$store.commit("application/setErrorProcessText", this.ticketsError || "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.");

                this.resetData();
            }
        }
    },

}
</script>

<style lang="scss" scoped>
@import "@/assets/modals.scss";

.user-identity {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1000;
}

.looking-animation {
    width: 340px;
    height: 340px;
    margin: 0 auto;
    position: relative;
    margin-bottom: -40px;
}

.buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;

    .modal-btn {
        margin: initial;
    }
}

/* imac 24" */
/* 2048 x 1152 */
@media (min-width: 2048px) {}

/* 2304-1470 */
@media (min-width: 2304px) {}

/* 2470 - 1328 */
@media (min-width: 2470px) {}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .buttons-wrapper {
        gap: 35px;
    }
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {
    .looking-animation {
        width: 360px;
        height: 360px;
        margin-bottom: -60px;
    }

    .buttons-wrapper {
        gap: 45px;
    }
}

/* 3000-1870 */
@media(min-width: 3000px) {}

/*3200-1800*/
@media(min-width: 3200px) {
    .looking-animation {
        width: 370px;
        height: 370px;
        margin-bottom: -70px;
    }

    .buttons-wrapper {
        gap: 60px;
    }
}

/*3360-1890 1695*/
@media(min-width:3360px) {}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .looking-animation {
        width: 400px;
        height: 400px;
        margin-bottom: -90px;
    }

    .buttons-wrapper {
        gap: 80px;
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .looking-animation {
        width: 320px;
        height: 320px;
    }
}

/*1688-1080*/
@media(max-width: 1688px) {
    .modal-btn-sm {
        width: 240px;
    }

    .buttons-wrapper {
        gap: 30px;
    }
}

/*1680-1080*/
@media(max-width: 1680px) {
    .looking-animation {
        width: 310px;
        height: 310px;
    }
}

/*1640-1080*/
@media(max-width: 1640px) {}

/* 1600 - 757 */
@media (max-width: 1600px) {
    .looking-animation {
        width: 300px;
        height: 300px;
    }

    .modal-btn-sm {
        width: 200px;
    }

    .buttons-wrapper {
        gap: 35px;
    }
}

/*1536-864*/
@media(max-width:1536px) {}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    .looking-animation {
        width: 280px;
        height: 280px;
    }
}

/*1366-638*/
@media (max-width:1366px) {
    .buttons-wrapper {
        gap: 40px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {}

/* 1200-1920 */
@media (max-width:1200px) {}

/*1134x712*/
@media(max-width:1134px) {}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {
    .looking-animation {
        width: 260px;
        height: 260px;
    }
}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {
    .looking-animation {
        width: 240px;
        height: 240px;
    }

    .modal {
        padding: 45px 25px;
    }
}

/* 900x1600 */
@media(max-width: 900px) {
    .looking-animation {
        width: 220px;
        height: 220px;
    }
}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .modal {
        padding: 45px 20px;
    }

    .buttons-wrapper {
        gap: 30px;
    }
}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {
    .buttons-wrapper {
        gap: 11px;
    }
}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {
    .modal {
        padding: 30px 20px;
    }

    .modal-btn-sm {
        width: 180px;
    }

    .modal-msg {
        margin-bottom: 30px;
    }
}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .modal-btn-sm {
        width: 170px;
    }
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {
    .modal {
        padding: 30px 15px;
    }
}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}
</style>
